import type { TAutocompleteOption } from '~/components/AutocompleteField/types.ts';
import {
  BorrowerType,
  type TQuarter,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';

export const INITIAL_BANK_OPTIONS_COUNT = 20;
export const MAX_DECIMAL_FRACTION_DIGITS = 5;

export const FINANCIAL_CONDITION_FIELD_LABELS = {
  bank: 'Банк',
  currency: 'Валюта',
  maturityDate: 'Дата погашення',
  balanceLine: 'Рядок балансу',
  reportLine: 'Рядок фінансової звітності',
  amountThousands: 'Сума, тис. од.',
  sharePercent: 'Питома вага, %',
} as const;

export const BORROWER_TYPE_OPTIONS = [
  { value: BorrowerType.LegalEntity, label: 'Юридична особа' },
  { value: BorrowerType.SoleTrader, label: 'Фізична особа-підприємець (ФОП)' },
];

export const LIABILITY_REPORT_LINE_CODES = {
  liabilitiesAnnual: ['1510', '1515', '1525', '1595', '1600', '1610', '1690'],
  liabilitiesQuarterly: ['1510', '1595'],
} as const;

export const EXPENSE_REPORT_LINE_CODES = {
  expensesAnnual: ['2180', '2270', '2150', '2200', '2220', '2240', '2255'],
  expensesQuarterly: ['2180', '2270'],
  expensesQuarterlySmall: [],
} as const;

export const QUARTER_OPTIONS: TAutocompleteOption[] = [
  { value: 'quarter:1', label: 'I квартал' },
  { value: 'quarter:2', label: 'II квартал' },
  { value: 'quarter:3', label: 'III квартал' },
  { value: 'quarter:4', label: 'IV квартал' },
];

export const MONTH_OPTIONS: TAutocompleteOption[] = [
  { value: 'month:1', label: 'Січень' },
  { value: 'month:2', label: 'Лютий' },
  { value: 'month:3', label: 'Березень' },
  { value: 'month:4', label: 'Квітень' },
  { value: 'month:5', label: 'Травень' },
  { value: 'month:6', label: 'Червень' },
  { value: 'month:7', label: 'Липень' },
  { value: 'month:8', label: 'Серпень' },
  { value: 'month:9', label: 'Вересень' },
  { value: 'month:10', label: 'Жовтень' },
  { value: 'month:11', label: 'Листопад' },
  { value: 'month:12', label: 'Грудень' },
];

export const REPORT_PERIOD_OPTIONS = [...QUARTER_OPTIONS, ...MONTH_OPTIONS];

export const QUARTER_MONTHS: Record<TQuarter, [string, string, string]> = {
  '1': ['Січень', 'Лютий', 'Березень'],
  '2': ['Квітень', 'Травень', 'Червень'],
  '3': ['Липень', 'Серпень', 'Вересень'],
  '4': ['Жовтень', 'Листопад', 'Грудень'],
};

export const CREDIT_PRODUCT_TYPE_OPTIONS: TAutocompleteOption[] = [
  { value: 'loan', label: 'К — кредит' },
  { value: 'nonRevolvingCreditLine', label: 'НКЛ — невідновлювана кредитна лінія' },
  { value: 'revolvingCreditLine', label: 'ВКЛ — відновлювана кредитна лінія' },
  { value: 'trancheLine', label: 'ТЛ — траншева лінія' },
  { value: 'overdraft', label: 'ОВ — овердрафт' },
  { value: 'factoring', label: 'Ф — факторинг' },
  { value: 'financialLeasing', label: 'ФЛ — фінансовий лізинг' },
];

export const CREDIT_PRODUCT_TYPE_CODES: Record<string, string> = {
  loan: 'К',
  nonRevolvingCreditLine: 'НКЛ',
  revolvingCreditLine: 'ВКЛ',
  trancheLine: 'ТЛ',
  overdraft: 'ОВ',
  factoring: 'Ф',
  financialLeasing: 'ФЛ',
};
